/* Stienhardt - instant loading feedback on the Add to Ring / Buy Loose CTAs
   (2026-06-27). The click navigates fast (~150ms) but the destination collection
   takes ~2s to load, so the button shows a spinner so it doesn't feel broken.
   Purely visual (capture-phase, never blocks the real handler). Revert = remove
   file + <script> + CSS. */
(function () {
  'use strict';
  function bind(){
    document.querySelectorAll('.product-form__add-to-setting .btn, .product-form__buy-loose .btn, .sticky-button-price-wrapper .btn').forEach(function(btn){
      if(btn.__spLoad) return; btn.__spLoad=true;
      btn.addEventListener('click', function(){
        btn.classList.add('sp-cta-loading');
        setTimeout(function(){ btn.classList.remove('sp-cta-loading'); }, 8000); /* safety: clear if no nav */
      }, true);
    });
  }
  var n=0,iv=setInterval(function(){ n++; bind(); if(n>80) clearInterval(iv); },250);
  var mp=document.getElementById('mainproduct'); if(mp && typeof MutationObserver!=='undefined') new MutationObserver(bind).observe(mp,{childList:true,subtree:true});
})();
